import React from 'react';
import type { RowType } from '@atlaskit/dynamic-table/types';
import {
	NAME,
	HIERARCHY_LEVEL,
	RELATED_SCHEMES,
	ACTIONS,
} from '@atlassian/jira-admin-pages-issue-types-common/src/constants.tsx';
import type { IssueType } from '@atlassian/jira-admin-pages-issue-types-common/src/types.tsx';
import { ActionsCell } from './actions';
import { HierarchyLevelCell } from './hierarchy-level';
import { NameCell } from './name';
import { RelatedSchemesCell } from './related-schemes';

export const getTableRows = (values: IssueType[] = []): RowType[] =>
	values.map((rowValue) => ({
		key: `issue-type-${rowValue.id}`,
		cells: [
			{
				key: NAME,
				content: (
					<NameCell
						name={rowValue.name}
						description={rowValue.description}
						iconUrl={rowValue.iconUrl}
					/>
				),
			},
			{
				key: HIERARCHY_LEVEL,
				content: <HierarchyLevelCell hierarchyLevel={rowValue.hierarchyLevel} />,
			},
			{
				key: RELATED_SCHEMES,
				content: <RelatedSchemesCell relatedSchemes={rowValue.relatedSchemes} />,
			},
			{
				key: ACTIONS,
				content: (
					<ActionsCell
						canDelete
						canTranslate
						issueTypeId={rowValue.id}
						issueType={rowValue}
						hierarchyLevel={rowValue.hierarchyLevel}
					/>
				),
			},
		],
	}));
